import React from "react";
import i18n from "i18next";
import k from "src/i18n/keys";

import { Checkbox } from "src/components/Unifize";
import EmbeddedFields from "./EmbeddedFields";
import { CellItem } from "../styles";

import type { FieldId } from "src/types";
import type {
  AiLinkedFieldSuggestionValues,
  AiSuggestionSelectionMatrix,
} from "src/ts-types";

type Props = {
  fieldId: FieldId;
  isDisabled: boolean;
  value: AiLinkedFieldSuggestionValues;
  toggleSuggestion?: (
    fieldId: FieldId,
    fieldSuggestionIndex: number,
    embeddedSuggestionIndex?: number,
  ) => void;
  isSuggestionSelected: (
    fieldId: FieldId,
    fieldSuggestionIndex: number,
    embeddedSuggestionIndex?: number,
  ) => boolean;
  selectionSuggestions: AiSuggestionSelectionMatrix;
};

const Link = ({
  fieldId,
  isDisabled,
  value,
  toggleSuggestion,
  isSuggestionSelected,
  selectionSuggestions,
}: Props) => {
  if (!value || !Array.isArray(value) || !toggleSuggestion) return null;

  const isMultiValue = value.length > 1;
  const isSingleValue = value.length === 1;

  return (
    <>
      {value.map((item, index) => {
        const embeddedSelections = selectionSuggestions[index] ?? new Set();
        const suggestionSelected = isSuggestionSelected(fieldId, index);
        const embeddedFieldSuggestions = item?.embeddedFields || [];
        return isMultiValue ? (
          <>
            <CellItem key={index}>
              {!isDisabled && (
                <Checkbox
                  isDisabled={isDisabled}
                  checked={suggestionSelected}
                  onChange={() => {
                    toggleSuggestion(fieldId, index);
                  }}
                  indeterminate={
                    suggestionSelected &&
                    embeddedFieldSuggestions.length > embeddedSelections.size
                  }
                />
              )}
              {item.title}
            </CellItem>
            {embeddedFieldSuggestions.length > 0 && (
              <EmbeddedFields
                disabled={isDisabled}
                values={item.embeddedFields}
                embeddedSelections={embeddedSelections}
                toggleEmbeddedSelection={(embeddedIndex) => {
                  toggleSuggestion(fieldId, index, embeddedIndex);
                }}
              />
            )}
          </>
        ) : isSingleValue ? (
          <>
            <span>{item.title || ""}</span>
            {embeddedFieldSuggestions.length > 0 && (
              <EmbeddedFields
                disabled={isDisabled}
                values={embeddedFieldSuggestions}
                embeddedSelections={embeddedSelections}
                toggleEmbeddedSelection={(embeddedIndex) => {
                  toggleSuggestion(fieldId, 0, embeddedIndex);
                }}
              />
            )}
          </>
        ) : (
          <span>{i18n.t(k.INVALID_VALUE)}</span>
        );
      })}
    </>
  );
};

export default Link;
